const errorMessages = {
  required: 'This field is required',
  email: 'Invalid email address',
  minLength: (min) => `Must be at least ${min} characters`,
  minDigits: (min) => `Must be at least ${min} digits`,
  maxLength: (max) => `Must be ${max} characters or less`,
  passwordStrength: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
  match: (field) => `Must match the ${field}`,
  date: 'Invalid date format',
  passwordMatch: "Passwords must match",
  url: "Invalid URL",
  phone: "Invalid phone number"
};

export default errorMessages;